import {
  IGradeUnitDayDTO,
  GradeUnitDayDTO,
} from '@models/grade-unit/grade-unit-day';
import { BLOCK_TYPES } from '@utils/constants';
import { StudentAnswerDTO } from './answer';
import { ITranscription } from './grade-unit/transcript';
import { INoteDTO } from './note';
import { QuizTypes } from './quiz-block';
import { PageContentDTO } from './page-content';
import { RetryDTO } from '@models/retry';
import { GradeLevel } from '@models/grade-level';
import { EdReviewNoteDto } from '@models/ed-review';

export interface IDayBlockDTO {
  id: number;
  position: number;
  dayId: number;
  pageId: number;
  blockType: BLOCK_TYPES;
  day: IGradeUnitDayDTO;
  notes?: INoteDTO[];
  pageContent?: PageContentDTO;
  gradeUnitId?: number;
  gradeUnitDayId?: number;
  gradeLevel?: GradeLevel;
  retries?: RetryDTO[];
  edReviews: EdReviewNoteDto[];
}

export interface IUpdateDayBlockPositionDto {
  id: number;
  position: number;
}

export class DayBlockDTO implements IDayBlockDTO {
  id: number = 0;
  position: number = 0;
  dayId: number = 0;
  pageId: number = 0;
  blockType = null;
  gradeUnitId?: number = null;
  gradeUnitDayId?: number = null;
  gradeLevel?: GradeLevel = null;
  day = new GradeUnitDayDTO();
  originalTranscription?: string = null;
  editedTranscription?: ITranscription = null;
  html?: string = null;
  notes?: INoteDTO[] = [];
  quizType?: QuizTypes;
  options?: IAnswerOption[];
  trueOrFalse?: boolean;
  text?: string;
  answers?: StudentAnswerDTO[] = [];
  pageContent?: PageContentDTO;
  retries?: RetryDTO[] = [];
  edReviews: EdReviewNoteDto[] = [];

  constructor(configOverride?: Partial<IDayBlockDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IAnswerOption {
  position: number;
  answer: string;
  correct: boolean | string;
  fileId?: string;
  fileBucket?: string;
  fileName?: string;
  fileLocation?: string;
  file?: File;
}

export class AnswerOption implements IAnswerOption {
  position: number;
  answer: string;
  correct: boolean;
  fileId?: string;
  fileBucket?: string;
  fileName?: string;
  fileLocation?: string;
  file?: File;

  constructor(params: IAnswerOption) {
    Object.assign(this, { ...params });
  }
}

export interface IDayBlockPayloadDTO {
  id?: number;
  file?: FileList;
  url?: string;
  blockType: BLOCK_TYPES;
  position?: number;
  pageId: number;
  gradeUnitDayId?: number;
  originalTranscription?: ITranscription;
  editedTranscription?: ITranscription;
  quizType?: QuizTypes;
  options?: IAnswerOption[];
  trueOrFalse?: boolean;
  text?: string;
  notes?: INoteDTO[];
  retries?: RetryDTO[];
  edReviews: EdReviewNoteDto[];
}

export class DayBlockPayloadDTO implements IDayBlockPayloadDTO {
  id: number = null;
  file: FileList = null;
  url = null;
  blockType: BLOCK_TYPES = BLOCK_TYPES.ImageBlock;
  position: number;
  pageId: number;
  gradeUnitDayId?: number;
  originalTranscription?: ITranscription = null;
  editedTranscription?: ITranscription = null;
  quizType?: QuizTypes;
  options?: IAnswerOption[] = [];
  trueOrFalse?: boolean;
  text?: string;
  notes?: INoteDTO[];
  retries?: RetryDTO[];
  edReviews: EdReviewNoteDto[] = [];

  constructor(configOverride?: Partial<IDayBlockPayloadDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
